import { memoize } from 'lodash-es'

export const getUserInfo = memoize(
  () => new Promise((resolve) => window.AP.getCurrentUser(resolve)),
)

export const getAddonToken = () => new Promise((resolve) => window.AP.context.getToken(resolve))

export const getLocation = () => new Promise((resolve) => window.AP.getLocation(resolve))

export const getFilter = async (filterID) => {
  const data = await window.AP.request({
    url: `/rest/api/2/filter/${filterID}`,
    contentType: 'application/json',
  })

  return JSON.parse(data.body)
}

export const buildFilterParams = async (filterID) => {
  const filterParams = new URLSearchParams()
  if (!filterID) return filterParams

  try {
    if (filterID < 0) {
      // it means predefined filter
      filterParams.set('filter', filterID)
      return filterParams
    }

    const filter = await getFilter(filterID)

    if (filter) {
      if (filter.favourite) {
        filterParams.set('filter', filterID)
        return filterParams
      }

      // if filter is not starred => use jql as parameter
      // due to gside does not support import from such filters
      filterParams.set('jql', filter.jql)
      return filterParams
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('unable to build filter params:', e)

    return filterParams
  }
}

export const getUserTimezone = async () =>
  new Promise((resolve) => window.AP.user.getTimeZone(resolve))
